<div class="home-screen-wrapper">
  <ion-row>
    <ion-col size="auto">
      <div class="lotto-social-img-wrap">
        <img class="lotto-social-img" src="assets/icon/lotto_social.svg" />
      </div>
    </ion-col>
    <ion-col>
      <mat-icon (click)="close()" class="cancel-icon">{{ "add-home-screen.close" | translate }}</mat-icon>
      <h1 class="home-screen-heading">{{ "add-home-screen.App" | translate }}</h1>
      <p class="lotto-social-site">{{ "add-home-screen.com" | translate }}</p>
      <p class="add-home-screen-content">
        {{ "add-home-screen.Add" | translate }}
      </p>
      <ion-button class="add-home-screen-btn" (click)="addToHomeScreen()">
        {{ "add-home-screen.home" | translate }}
      </ion-button>
    </ion-col>
  </ion-row>
</div>
